import * as React from 'react';

import { cn } from './lib/utils';
import { Separator } from './separator';
import { SidebarTrigger } from './sidebar';

interface PageHeaderProps extends React.ComponentProps<'header'> {
  /** Content rendered after the sidebar trigger and separator (typically breadcrumbs). */
  children?: React.ReactNode;
  /**
   * Optional actions pinned to the trailing (right) edge of the header, inline
   * with the breadcrumbs. The slot collapses (`empty:hidden`) when it renders
   * nothing, so a conditional actions component leaves no gap.
   */
  actions?: React.ReactNode;
}

function PageHeader({ className, children, actions, ...props }: PageHeaderProps) {
  return (
    <header
      data-slot="page-header"
      className={cn('flex h-16 shrink-0 items-center gap-2', className)}
      {...props}
    >
      <div className="flex items-center gap-2 px-4">
        <SidebarTrigger className="-ml-1" />
        <Separator orientation="vertical" className="mr-2 data-[orientation=vertical]:h-4" />
        {children}
      </div>
      {actions != null && (
        <div
          data-slot="page-header-actions"
          className="ms-auto flex items-center gap-2 px-4 empty:hidden"
        >
          {actions}
        </div>
      )}
    </header>
  );
}

export { PageHeader };
export type { PageHeaderProps };
